module.exports = __webpack_public_path__ + "img/missionaa.ca9a4560.png";